import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AppConstants } from '../../constants/app-constants';
import { ContractWarningDialogMode } from '../../enums/modes.enum';
import { ButtonComponent, ButtonConfig, ButtonVariant} from '../core/button/button.component';
export interface ContractWarningConfig {
  TITLE: string;
  MESSAGES: {
    DRAFT_INFO: string;
    RESTRICTIONS: string[]; 
    DRAFT_QUESTION: string; 
    INCOMPLETE_QUESTION: string;
  };
  BUTTONS: {
    SAVE_DRAFT: ButtonConfig;     
    FINALIZE: ButtonConfig;         
    CANCEL: ButtonConfig;         
    SAVE_NO_FINALIZE: ButtonConfig; 
  };
}

export interface ContractWarningDialogData {
  mode: number;
  onPrimary: () => void;
  onSecondary: () => void;
  config: ContractWarningConfig; 
}

@Component({
  selector: 'app-contract-warning-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, ButtonComponent],
  templateUrl: './contract-modals.component.html',
  styleUrls: ['./contract-modals.component.scss']
})
export class ContractWarningDialogComponent {
  readonly mode:number=ContractWarningDialogMode.DRAFT;
  buttonVariant = ButtonVariant;
  constructor(
    public dialogRef: MatDialogRef<ContractWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ContractWarningDialogData
  ) {}

  cancel() {
    this.dialogRef.close(false);
  }

  saveDraft() {
    this.data.onSecondary?.();
    this.dialogRef.close('draft');
  }

  finalize() {
    this.data.onPrimary?.();
    this.dialogRef.close('finalize');
  }
}